import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { Axios } from '../../axios-instance';
import { BaseError } from '@utils/types/shared/base';
import { ADMIN_LICENSE_KEYS_QUERY_KEY } from './use-get-admin-license-keys';

const revokeLicense = async (keyId: number): Promise<void> => {
  await Axios.post(`api/admin/licensing/keys/${keyId}/revoke`);
};

export const useRevokeLicense = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError<BaseError>, number>(revokeLicense, {
    onSuccess: () => {
      toast.success(t('license-revoked-successfully'));
      queryClient.invalidateQueries([ADMIN_LICENSE_KEYS_QUERY_KEY]);
    },
    onError: (error: AxiosError<BaseError>) => {
      const data = error.response?.data;
      let errorMessage = t('failed-to-revoke-license');

      if (data?.error_description) {
        errorMessage = data.error_description;
      } else if (data?.message) {
        errorMessage = data.message;
      } else if (data?.detail) {
        errorMessage = data.detail;
      }

      toast.error(errorMessage);
    }
  });
};
